import React, {useState,useContext,createContext,useEffect,useRef,}  from 'react'
import {Form,Button,Container,Card,Alert,Modal,Navbar,Accordion} from 'react-bootstrap'
import axios from 'axios'
import {UserContext} from '../UserContext'
import uuid from 'react-uuid'

export default function Thankyou() {

    const {exhibition}=useContext(UserContext)

  return (
    <Container fluid>
 
    <Alert variant='success'>
      <h4>Ευχαριστούμε για την εγγραφή // Thank you for your registration</h4>
      </Alert>
      Σας ευχαριστούμε πολύ για την υποβολή της αίτησης σας.
<br/><br/>
Κατόπιν επεξεργασίας της, θα σας αποσταλεί από τη γραμματεία στο email που έχετε δηλώσει η οριστική δήλωση συμμετοχής σε μορφή Pdf στην οποία θα αναγράφονται:
<br/><br/>
1. Το περίπτερο και ο αριθμός του stand<br/>
2. Οι τελικές χρεώσεις<br/><br/>

Για να οριστικοποιήσετε τη συμμετοχή σας παρακαλούμε όπως την εκτυπώσετε, υπογράψετε, σφραγίσετε και αποστείλετε πίσω στο email της γραμματείας της έκθεσης.
<br/><hr/><br/>
Thank you very much for submitting your application.
<br/><br/>
Τhe secretariat of the exhibition will check it thoroughly and will send you in the email you have declared, the final application form in Pdf format, where the pavilion, your stand No and all final charges will be mentioned.
<br/><br/>
In order to validate your participation, please print it, sign it, stamp it and send it back to the email of the exhibition secretariat.

<hr></hr>
<alert variant="secondary"><a href={exhibition.Website} target="_blank"><h4>{exhibition.Website}</h4></a></alert>
<br/><br/><br/>


      </Container>
  )
}
